/**
 * Reorders locally stored documents so that they follow the order returned by the server.
 * Documents missing from the server order (for example added locally after the last fetch)
 * are kept at the end, so nothing disappears from the table.
 *
 * @param items documents to reorder
 * @param order ids in the order returned by the server, undefined when nothing was fetched yet
 * @param idGetter reads the id matching the ids of the server order
 */
export function sortByServerOrder<T>(items: T[], order: string[] | undefined,
    idGetter: (it: T) => string): T[] {
    if (!order?.length) {
        return items;
    }

    const positions = new Map(order.map((id, index) => [id, index]));

    return [...items].sort((a, b) => {
        const positionA = positions.get(idGetter(a)) ?? Number.MAX_SAFE_INTEGER;
        const positionB = positions.get(idGetter(b)) ?? Number.MAX_SAFE_INTEGER;

        return positionA - positionB;
    });
}
